import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
const caseInfoConfirmationTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Case Information Confirmation',
  key: 'caseInfoConfirmationTemplate',
  cfId: {
    metadata: {
      layout: {
        rows: [
          ['cfId'],
          ['confirmCfId'],
        ],
      },
    },
    fields: {
      cfId: {
        label: 'Collection Function',
        type: 'password',
        initial: '',
        disabled: true,
      },
      confirmCfId: {
        label: 'Confirm Collection Function',
        type: 'select',
        initial: 'None',
        options: [
          {
            label: 'None',
            value: 'None',
          },
        ],
      },
    },
  },
  interceptType: {
    metadata: {
      layout: {
        rows: [
          ['type'],
          ['confirmType'],
        ],
      },
    },
    fields: {
      type: {
        label: 'Intercept Type',
        type: 'password',
        initial: '',
        disabled: true,
      },
      confirmType: {
        label: 'Confirm Intercept Type',
        type: 'select',
        initial: 'None',
        options: [
          {
            label: 'None',
            value: 'None',
          },
        ],
      },
    },
  },
};

export default caseInfoConfirmationTemplate;
